import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { FormMessageComponent } from './form-message.component';
import { FormMessagesComponent } from './form-messages.component';
import { FormValidateDirective } from './form-validate.component';
import { FormSubmittedDirective } from './form-submitted.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule
    ],
    exports: [
        FormMessageComponent,
        FormMessagesComponent,
        FormValidateDirective,
        FormSubmittedDirective
    ],
    declarations: [
        FormMessageComponent,
        FormMessagesComponent,
        FormValidateDirective,
        FormSubmittedDirective
    ]
})

export class FormValidationModule {
}
